import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Heading,
  Text,
  VStack,
  Button,
  useColorModeValue,
  Container,
  Alert,
  AlertIcon,
  AlertDescription,
  Avatar,
  HStack
} from '@chakra-ui/react';
import { AuthContext } from '../context/AuthContext';

function PendingApproval() {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  
  const bgColor = useColorModeValue('white', 'gray.700');
  
  return (
    <Container maxW="lg" py={12}>
      <Box bg={bgColor} p={8} rounded="md" boxShadow="lg">
        <VStack spacing={6} align="stretch">
          <Box textAlign="center">
            <Heading as="h1" size="xl" mb={4}>Approval Pending</Heading>
            
            {user && (
              <HStack spacing={4} justifyContent="center" mb={4}>
                <Avatar size="md" src={user.picture} name={user.name} />
                <Box textAlign="left">
                  <Text fontWeight="bold">{user.name}</Text>
                  <Text fontSize="sm" color="gray.500">{user.email}</Text>
                </Box>
              </HStack>
            )}
          </Box>
          
          <Alert status="info" variant="subtle" flexDirection="column" alignItems="center" justifyContent="center" textAlign="center" borderRadius="md" py={4}>
            <AlertIcon boxSize={6} mr={0} mb={3} />
            <AlertDescription maxWidth="sm">
              Your account registration request has been sent to the administrators for approval.
              You will be able to access the system once your account has been approved.
            </AlertDescription>
          </Alert>
          
          <Text color="gray.500" fontSize="sm" textAlign="center">
            Only users with a @wishfin.com email address are allowed. If you have any questions, please contact the system administrator.
          </Text>
          
          <Button colorScheme="red" variant="outline" onClick={logout}>
            Logout
          </Button>
        </VStack>
      </Box>
    </Container>
  );
}

export default PendingApproval;